<template>
    <card-details-form
        v-if="stripeMounted"
        class="max-w-sm mx-auto pb-24"
        @registered="handleSuccessfulRegistration"
        :allow-skip-card="allowNoCard"
        :enable-coupon-field="false"/>
</template>

<script>
import { SECTION_DELIVERY } from '@/constants/Registration';
import CardDetailsForm from '@/components/forms/register/CardDetailsForm';

export default {
    name: 'CardDetails',
    mounted: function() {
        if (!this.$store.getters['register/getSectionCompleted'](SECTION_DELIVERY)) {
            this.$router.push({ name: 'register.delivery' });
        }

        this.$scrollTo('#app');
    },
    methods: {
        handleSuccessfulRegistration() {
            this.$store.commit('register/resetState');
            this.$router.push({ name: 'canvasser-register.confirmation' });
        },
    },
    computed: {
        source() {
            return this.$store.getters['canvasser/getSource'];
        },
        allowNoCard() {
            return this.source ? !this.source.card_required : false;
        },
        stripeMounted() {
            return this.$store.getters['cookies/isStripeMounted'];
        },
    },
    components: {
        CardDetailsForm,
    },
};
</script>
